import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { KycInfo } from "../../../models/cartable.model";

interface Props {
  data: KycInfo;
}
const VideoAuthorization = ({ data }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Grid
        container
        sx={{
          border: "2px solid #C1C7CB",
          borderRadius: "5px",
          width: "100%",
          height: "fit-content",
          padding: "2rem",
          position: "relative",
        }}
        flexDirection={isMobile ? "column" : "row"}
      >
        <Typography
          sx={{
            position: "absolute",
            top: "-12px",
            right: "30px",
            backgroundColor: "#fff",
            color: "#1D4A87",
            fontSize: "1.2rem",
            fontWeight: "bold",
            paddingInline: "5px",
          }}
        >
          احراز هویت ویدیویی
        </Typography>
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            borderLeft: isMobile ? "" : "2px solid #C1C7CB",
            padding: "1rem",
          }}
        >
          <Typography
            sx={{ color: "#34495E", fontSize: "1rem", fontWeight: "bold" }}
          >
            <span
              style={{
                color: "#9AAFC4",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              متن احراز هویت:
            </span>{" "}
            {data?.kycText}
          </Typography>
          <Box
            sx={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <video
              src={data?.kycVideoUrl}
              controlsList="nodownload"
              playsInline
              controls
              muted={false}
              className="VideoAuthorization-video"
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={4} sx={{ padding: "1rem" }}>
          <Grid container flexDirection={"column"} gap={"2rem"} height={"100%"}>
            {data?.nationalCardFront?.fileUrl && (
              <Grid item height={"50%"} width={"100%"}>
                <a
                  href={`${data?.nationalCardFront?.fileUrl!}/true`}
                  target="_blank"
                >
                  <img
                    className="VideoAuthorization-image"
                    src={data?.nationalCardFront?.fileUrl}
                    alt="تصویر روی کارت ملی"
                  />
                </a>
              </Grid>
            )}
            <Grid item>
              <Typography
                sx={{ color: "#34495e", fontSize: "1rem", fontWeight: "bold" }}
              >
                <span style={{ color: "#9AAFC4" }}>تاریخ ثبت:</span>{" "}
                {data?.kycDatePersian}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default VideoAuthorization;
